import { Fragment } from "react";
import poweredByEvvnt from "src/assets/images/powered_by_evvnt.png";
import ButtonLink from "src/components/atoms/ButtonLink";
import Image from "src/components/atoms/Image";
import CreateEventButton from "src/components/molecules/CreateEventButton";
import LandscapeItem from "src/components/organisms/events/LandscapeItem";
import SearchBar from "src/components/organisms/SearchBar/Widget";
import Event from "src/models/Event";
import { usePluginConfig } from "../../../contexts/pluginContext";
import { createListWithAds } from "../../../utils/adHelper";
import { exists } from "../../../utils/objects";
import WidgetAd from "../../molecules/WidgetAd";

const WidgetLandscape = ({ rawEvents, adPosition, category, frameConfig }) => {
	const pluginConfig = usePluginConfig();
	const publisherSettings = pluginConfig.publisherSettings;
	const events = rawEvents.map((event) => new Event(event, publisherSettings));
	const listWithAds = createListWithAds(
		events,
		exists(adPosition) ? [adPosition] : [],
	);
	/*
    This comment needs to stay here so our dynamic styles are not purged

    @lg:grid-cols-1 @lg:grid-cols-2 @lg:grid-cols-3 @lg:grid-cols-4 @lg:grid-cols-5
  */
	const EventsGrid = ({ children }) => (
		<div
			className={`grid grid-cols-1 @sm:grid-cols-2 ${
				frameConfig.options.number > 2 ? "@md:grid-cols-3" : ""
			} @lg:grid-cols-${frameConfig.options.number} gap-3 my-2 bg-white`}
		>
			{children}
		</div>
	);

	const EventsContainer = ({ children }) => (
		<div className="flex-1 relative z-1 bg-white rounded">{children}</div>
	);

	const eventClass = (index) => {
		switch (index) {
			case 4:
			case 3: {
				return "hidden @lg:block";
			}
			case 2: {
				return "hidden @md:block";
			}
			case 1: {
				return "hidden @sm:block";
			}
		}
	};

	return (
		<main className="flex flex-col items-center min-h-screenw-full text-gray-900 max-w-7xl m-auto">
			<div className="flex flex-col-reverse @sm:flex-row w-full">
				<div className="flex-grow">
					<SearchBar category={category} horizontal />
				</div>
				<div className="flex-initial mb-2 @sm:mb-0 @sm:ml-2">
					<CreateEventButton extraClasses="normal-case font-bold text-sm w-full @sm:w-64 h-11" />
				</div>
			</div>

			<div className="flex mt-0 w-full">
				<EventsContainer>
					<EventsGrid>
						{listWithAds.map((listElement, index) => (
							<Fragment key={`event-list-item-${index}`}>
								<div className={eventClass(index)}>
									{listElement.isAd && (
										<WidgetAd
											widgetType="horizontal_widget"
											utmSource={publisherSettings.publisher.id}
											utmMedium="widget"
											utmCampaign="promote_asset"
											customAdClasses={
												listWithAds.length <= 3 ? "max-h-64" : ""
											}
											horizontal
										/>
									)}
									{!listElement.isAd && (
										<LandscapeItem event={listElement.event} trackView={true} />
									)}
								</div>
							</Fragment>
						))}
					</EventsGrid>
				</EventsContainer>
			</div>
			<div className="flex items-center justify-between mt-1 w-full">
				<ButtonLink
					text="More Events"
					href={publisherSettings.publisher.url}
					target="_top"
					extraClasses="shadow-none text-sm font-bold normal-case px-10"
				/>
				<a
					href="https://evvnt.com"
					target="_blank"
					className="block opacity-60 hover:opacity-100 transition-opacity"
					rel="noopener"
				>
					<Image
						src={poweredByEvvnt}
						alt="Powered by Evvnt"
						className="h-[18px] w-auto"
					/>
				</a>
			</div>
		</main>
	);
};

export default WidgetLandscape;
